import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Grid,
    Stack,
    Typography
} from '@mui/material';
import React from 'react';
import { PastCyclesModel } from '../../../lib/models/PastCyclesModel';
import ExpandIcon from '../../Utils/ExpandIcon';
import PastCyclesAncillaryHoursTable from './PastCyclesAncillaryHoursTable';
import PastCyclesCaseHoursTable from './PastCyclesCaseHoursTable';

export type PastCyclesListItemProps = {
    data: PastCyclesModel;
};

const PastCyclesListItem = ({
    data: {
        id,
        startDate,
        endDate,
        reviewMinutesNumber: reviewHoursTotal,
        ancillaryMinutesNumber: ancillaryHoursTotal,
        totalHours
    }
}: PastCyclesListItemProps) => {
    const [isExpanded, setIsExpanded] = React.useState(false);

    const onAccordionExpandChange = (event: React.SyntheticEvent, expanded: boolean) => {
        setIsExpanded(expanded);
    };
    return (
        <Accordion disableGutters elevation={0} onChange={onAccordionExpandChange}>
            <AccordionSummary expandIcon={<ExpandIcon isExpanded={isExpanded} />}>
                <Grid container columnSpacing={1} rowSpacing={1}>
                    <Grid item lg={3} md={6} sm={6} xs={6}>
                        <Typography fontSize={(t) => t.typography.fontSize} fontWeight={'medium'}>
                            {new Date(startDate).toLocaleDateString('en-US')} -{' '}
                            {new Date(endDate).toLocaleDateString('en-US')}
                        </Typography>
                    </Grid>
                    <Grid
                        item
                        lg={3}
                        md={6}
                        sm={6}
                        xs={6}
                        display="flex"
                        gap={1}
                        alignItems="baseline">
                        <Typography
                            fontSize={13}
                            color={(t) => t.palette.cardSubtitle.main}
                            fontWeight={'medium'}>
                            Review Minutes:
                        </Typography>
                        <Typography fontSize={14} fontWeight={'medium'}>
                            {reviewHoursTotal}
                        </Typography>
                    </Grid>
                    <Grid
                        item
                        lg={3}
                        md={6}
                        sm={6}
                        xs={6}
                        display="flex"
                        gap={1}
                        alignItems="baseline">
                        <Typography
                            fontSize={13}
                            color={(t) => t.palette.cardSubtitle.main}
                            fontWeight={'medium'}>
                            Ancillary Minutes:
                        </Typography>
                        <Typography fontSize={14} fontWeight={'medium'}>
                            {ancillaryHoursTotal}
                        </Typography>
                    </Grid>
                    <Grid
                        item
                        lg={3}
                        md={6}
                        sm={6}
                        xs={6}
                        display="flex"
                        gap={1}
                        alignItems="baseline">
                        <Typography
                            fontSize={14}
                            // color={(t) => t.palette.cardSubtitle.main}
                            fontWeight={'700'}>
                            Total Hours:
                        </Typography>
                        <Typography fontSize={14} fontWeight={'700'}>
                            {totalHours}
                        </Typography>
                    </Grid>
                </Grid>
            </AccordionSummary>
            <AccordionDetails>
                <Stack gap={1}>
                    <PastCyclesCaseHoursTable invoiceCycleId={id} />
                    <PastCyclesAncillaryHoursTable invoiceCycleId={id} />
                </Stack>
            </AccordionDetails>
        </Accordion>
    );
};

export default PastCyclesListItem;
